import { environment } from "src/environments/environment";

export const onlineApiUrlBase = environment.apiUrl;
export const testApiUrlBase = environment.apiTestUrl;

export const apiUrlBase = onlineApiUrlBase;

const apiEndpoints = {
  apiUrlBase: apiUrlBase,
  signinUrl: `${apiUrlBase}/auth/login/`,
  signupUrl: `${apiUrlBase}/auth/signup/`,
  registerUrl: `${apiUrlBase}/auth/register/`,
  signoutUrl: `${apiUrlBase}/auth/signout/`,
  forgotPasswordUrl: `${apiUrlBase}/auth/reset-password/`,
  resetPasswordUrl: `${apiUrlBase}/auth/reset-password-confirm/`,
  firstResetPasswordUrl: `${apiUrlBase}/auth/first-login/change-password/`,
  changePasswordUrl: `${apiUrlBase}/auth/set-password/`,
  verifyEmailUrl: `${apiUrlBase}/auth/users/activation/`,
  resendVerificationUrl: `${apiUrlBase}/auth/activation/resend/`,
  logoutUrl: `${apiUrlBase}/auth/logout/`,
  uploadProfileUrl: `${apiUrlBase}/users/profile/image/`,
  usersUrl: `${apiUrlBase}/users/`,
  adminUrl: `${apiUrlBase}/admin/`,
  authUrl: `${apiUrlBase}/auth/`,
  groupsUrl: `${apiUrlBase}/groups/`,
  rolesUrl: `${apiUrlBase}/roles/`,
  permissionsUrl: `${apiUrlBase}/permissions/`,
  resourcesCategoriesUrl: `${apiUrlBase}/resources-categories/`,
  resourcesUrl: `${apiUrlBase}/resources/`,
}

export default apiEndpoints;
